import React, { useEffect } from 'react'
import { TextFieldDisplayType } from '@deal/components'
import { ListPathFlowQuestionDefinition } from '#src/components/Path/Question'
import DropDown from './DropDown'
import MultiSelect from './MultiSelect'
import SelectList from './SelectList'
import { ListPathFlowQuestionType } from '#src/generated/graphql'

export interface ListPathFlowQuestionProps extends ListPathFlowQuestionDefinition<CustomProps> {
  value: string | null
}

interface CustomProps {
  className?: string
  hideIcon?: boolean
  display?: TextFieldDisplayType
}

const ListPathFlowQuestion: React.SFC<ListPathFlowQuestionDefinition<CustomProps>> = ({
  question,
  onFieldValidityChanged,
  onFieldValueChanged,
  ...rest
}) => {
  useEffect(() => {
    const questionValues = question.listUserInput.value

    if (!question.required) {
      onFieldValidityChanged(true)
    }

    if (questionValues && questionValues.length > 0) {
      onFieldValueChanged({ value: questionValues })
      onFieldValidityChanged(true)
    }
  }, [])

  let SelectComponent: React.SFC<ListPathFlowQuestionProps>
  switch (question.listType) {
    case ListPathFlowQuestionType.MULTI_SELECT_LIST:
    case ListPathFlowQuestionType.SINGLE_SELECT_LIST:
      SelectComponent = SelectList
      break

    case ListPathFlowQuestionType.MULTI_SELECT_PILLS:
      SelectComponent = MultiSelect
      break

    case ListPathFlowQuestionType.DROP_DOWN:
      SelectComponent = DropDown
      break

    default:
      throw new Error(`Unhandled ListPathFlowQuestion type [${question.listType}]`)
  }

  return (
    <SelectComponent
      question={question}
      onFieldValidityChanged={onFieldValidityChanged}
      onFieldValueChanged={onFieldValueChanged}
      value={question.listUserInput.value ? question.listUserInput.value.join(',') : null}
      {...rest}
    />
  )
}

export default ListPathFlowQuestion
